import { useState } from "react";

import { ProjectDeliverablesScreen_TableFragment } from "../../../fragments.generated";
import { mapTableToHtmlForClipboard } from "./mapTableToHtmlForClipboard";
import { mapTableToTextForClipboard } from "./mapTableToTextForClipboard";

export function useClipboardToTable(table: ProjectDeliverablesScreen_TableFragment) {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        const html = mapTableToHtmlForClipboard(table);
        const text = mapTableToTextForClipboard(table);

        await navigator.clipboard.write([
            new ClipboardItem({
                "text/html": new Blob([html], { type: "text/html" }),
                "text/plain": new Blob([text], { type: "text/plain" }),
            }),
        ]);

        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return { copied, handleCopy };
}
